import React from "react";
import Box from "@mui/material/Box";

const AppSumoMark = ({sx = {}}) => (
    <Box
        component="span"
        role="img"
        aria-label="AppSumo"
        sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 112,
            height: 36,
            borderRadius: "6px",
            bgcolor: "#FFBD00",
            color: "#171717",
            fontFamily: "Inter, sans-serif",
            fontSize: 14,
            fontWeight: 800,
            letterSpacing: "0.045em",
            lineHeight: 1,
            flexShrink: 0,
            ...sx,
        }}
    >
        APPSUMO
    </Box>
);

export default AppSumoMark;
